var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObj
  }, _vm._l((_vm.currentValue), function(i) {
    return _c('label', {
      class: _vm.tagClass(i)
    }, [_vm._v("\n\t " + _vm._s(i.label) + "\n\t"), (_vm.removable) ? _c('a', {
      attrs: {
        "name": "remove"
      },
      on: {
        "click": function($event) {
          _vm.del(i)
        }
      }
    }, [_c('n3-icon', {
      attrs: {
        "type": "times"
      }
    })], 1) : _vm._e()])
  }))
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7b3273ba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b3273ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tags/n3Tags.vue
// module id = 644
// module chunks = 0 1